module.exports = __webpack_public_path__ + "img/home-why.312fa8bd.jpg";